var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.text.length > 0)?_c('div',{staticClass:"banner banner-footer has-text-weight-semibold has-text-info has-background-primary-light is-fullwidth"},[_c('div',{ref:"textSpan",class:{
      'move-text': _setup.wraps,
    }},[_vm._v(" "+_vm._s(_setup.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }